import * as types from "../actions/actionTypes";

const initialState = {
  regions: [],
  countries: [],
  states: [],
  defualtValues: [],
  rentPeriods: [],
  UOM: [],
  costCurrency: [],
  userRoles: [],
};

export default function referenceReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_REGIONS: {
      const { data } = action.payload;

      return {
        ...state,
        regions: data,
      };
    }

    case types.GET_COUNTRIES: {
      const { data } = action.payload;

      return {
        ...state,
        countries: data,
      };
    }

    case types.GET_STATES: {
      const { data } = action.payload;

      return {
        ...state,
        states: data,
      };
    }

    case types.GET_DEFAULT_VALUES_ON_COUNTRY: {
      const { data } = action.payload;

      return {
        ...state,
        defualtValues: data,
      };
    }

    case types.GET_RENT_PERIOD: {
      const { data } = action.payload;

      return {
        ...state,
        rentPeriods: data,
      };
    }

    case types.GET_UNITS_OF_MEASUREMENT: {
      const { data } = action.payload;

      return {
        ...state,
        UOM: data,
      };
    }

    case types.GET_COST_CURRENCY: {
      const { data } = action.payload;

      return {
        ...state,
        costCurrency: data ? data.sort((a, b) => a.code.localeCompare(b.code)) : [],
      };
    }

    case types.GET_DISTINCT_USER_ROLES: {
      const { data } = action.payload;

      return {
        ...state,
        userRoles: data,
      };
    }

    default:
      return state;
  }
}
